import { useState } from 'react';
import { HeadlineRotator } from './HeadlineRotator';
import { BuildCard } from './BuildCard';
import { StatusPanel } from './StatusPanel';
import { DeployChip } from './DeployChip';
import { LOCALES, type Locale } from '../i18n/locales';

export function Hero(): JSX.Element {
  const [locale, setLocale] = useState<Locale>(LOCALES[0]!);

  return (
    <section className="hero">
      <div className="hero__glow" aria-hidden="true" />
      <div className="hero__dots" aria-hidden="true" />
      <div className="container">
        <div className="hero__grid">
          <div className="hero__col">
            <HeadlineRotator onLocaleChange={setLocale} />
          </div>

          <div className="panel-stack">
            <BuildCard locale={locale} />
            <DeployChip locale={locale} />
            <StatusPanel locale={locale} />
          </div>
        </div>
      </div>
    </section>
  );
}
